<div
  class="cb-battle-player"
  [class.nuclear]="battle().mode === 'nuclear' && !showResults()"
  [class.equity]="battle().mode === 'equity' && !showResults()"
  [class.crazy]="battle().mode === 'crazy' && !showResults()"
  [class.normal]="battle().mode === 'normal' && !showResults()"
  [class.player]="!!player()"
  [class.lose-opacity]="
    showResults() && !isWinner() && animation() === 'finished'
  "
  [class.lose]="showResults() && !isWinner()"
  [class.win]="showResults() && isWinner()"
>
  @if (player()) {
  <div class="cb-battle-player--player" @fadeInAnimation>
    @if (showResults() && isWinner()) {
    <img
      class="cb-battle-player--crown"
      @fadeInOutAnimation
      src="assets/images/king/crown.png"
    />
    }
    <app-player-row
      (click)="
        player()!.is_bot
          ? null
          : contextMenuService.open($event, { user: player()! })
      "
      [player]="player()!"
      [style.cursor]="player()!.is_bot ? 'default' : 'pointer'"
    >
    </app-player-row>
  </div>

  <div
    @fadeInAnimation
    class="cb-battle-player--value"
    [class.nuclear]="!showResults() && battle().mode === 'nuclear'"
    [class.equity]="!showResults() && battle().mode === 'equity'"
    [class.crazy]="!showResults() && battle().mode === 'crazy'"
    [class.normal]="!showResults() && battle().mode === 'normal'"
    [class.green]="showResults() && isWinner()"
    [class.red]="showResults() && !isWinner()"
  >
    <app-balance-icon
      [color]="
        showResults() && isWinner()
          ? 'var(--green)'
          : showResults() && !isWinner()
          ? 'var(--red)'
          : battle().mode === 'nuclear'
          ? 'var(--case-battle-nuclear)'
          : battle().mode === 'equity'
          ? 'var(--case-battle-equity)'
          : battle().mode === 'crazy'
          ? 'var(--case-battle-crazy)'
          : battle().mode === 'normal'
          ? 'var(--case-battle-normal)'
          : 'var(--yellow)'
      "
      [balance]="player()?.balance ?? 'skins'"
    ></app-balance-icon>
    <number-flow style="color: currentColor" #numberFlow></number-flow>
  </div>
  } @else {
  <div class="cb-battle-player--placeholder" @fadeInAnimation>
    <div class="cb-battle-player--placeholder__avatar">?</div>
    <span class="dots-animation">Waiting for player</span>
  </div>

  <button
    class="cb-battle-player--button"
    (click)="isHost() ? handleCallBots() : handleJoinBattle()"
  >
    <app-game-icon color="black" [game]="'Case Battles'"></app-game-icon>

    @if (isHost()) { call bots } @else { join for
    <app-cost
      color="var(--black)"
      fontWeight="700"
      [gap]="4"
      [cost]="battle().value"
      [balanceType]="sessionService.balanceType()"
    />
    }
  </button>
  }

  <div class="cb-battle-player--slot">slot: {{ slot() }}</div>
</div>
